const BankDetailsIconWithWhiteBG = () => {
  return (
    <svg
    className="w-11 h-11 md:w-16 md:h-16"

      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="63"
        height="63"
        rx="7.5"
        fill="white"
        stroke="#E9EEFE"
      />
      <path
        d="M51.7305 24.0203C51.5648 21.5672 49.2656 18.7812 46.7844 18.3766C36.9641 16.7039 27.0586 21.1977 17.0656 20.3203C14.6055 20.1297 12.4445 21.5602 12.2695 24.0203C11.9102 29.4727 11.9102 34.9242 12.2695 40.3766C12.4352 42.8297 14.7344 45.6148 17.2156 46.0203C27.0359 47.693 36.9414 43.1992 46.9344 44.0766C49.3945 44.268 51.5555 42.8359 51.7305 40.3766C52.0898 34.9242 52.0898 29.4727 51.7305 24.0203Z"
        fill="#5170CD"
      />
      <path
        d="M17.0754 20.3394C14.6152 20.1488 12.4543 21.5793 12.2793 24.0394C12.1199 26.4519 12.0316 28.8652 12.0137 31.2777C12.0316 33.691 12.1207 36.1051 12.2793 38.5183C12.3027 38.8707 12.3723 39.2293 12.4777 39.5871C15.2324 40.8605 18.3004 41.5723 21.5348 41.5723C33.4715 41.5723 43.148 31.8957 43.148 19.959C43.148 19.3105 43.1191 18.6683 43.0637 18.034C34.4668 17.7746 25.8051 21.1058 17.0754 20.3394Z"
        fill="#718AD6"
      />
      <path
        d="M33.1567 39.2492C32.8931 39.2492 32.6431 39.1393 32.4646 38.9471L27.1912 33.2672C26.8369 32.8854 26.8588 32.2866 27.2406 31.9323C27.4164 31.7703 27.6443 31.6796 27.8833 31.6796H30.4926C31.3989 31.6796 32.2202 31.1468 32.5909 30.3228H28.7567C28.2349 30.3146 27.8174 29.8834 27.8284 29.3615C27.8366 28.8506 28.2486 28.4414 28.7567 28.4332H32.5882C32.2147 27.6092 31.3962 27.0791 30.4926 27.0791H27.8833C27.3615 27.0791 26.9385 26.6561 26.9385 26.1343C26.9385 25.6124 27.3615 25.1895 27.8833 25.1895H36.1148C36.6367 25.1895 37.0596 25.6124 37.0596 26.1343C37.0596 26.6561 36.6367 27.0791 36.1148 27.0791H33.9944C34.2664 27.4911 34.4641 27.9498 34.574 28.4332H36.1176C36.6394 28.4414 37.0569 28.8726 37.0459 29.3945C37.0377 29.9053 36.6257 30.3146 36.1176 30.3228H34.5767C34.1345 32.2234 32.4426 33.5693 30.4926 33.572H30.0531L33.8516 37.6644C34.2059 38.0462 34.184 38.645 33.8022 38.9993C33.6264 39.1586 33.3957 39.2492 33.1567 39.2492Z"
        fill="#FDCE2F"
      />
    </svg>
  );
};
export default BankDetailsIconWithWhiteBG;
